import path from 'ramda/src/path'

export default state => path(['app', 'userData', 'creatorData', 'image'], state)
